export default __webpack_public_path__ + "static/starter-5e6a4d0a3151edb517147bd6ad7fd476.png";